/* eslint-disable no-alert */
/* eslint-disable no-restricted-globals */
import React from 'react';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';

import { Theme, useMediaQuery } from '@mui/material';
import { AudienceType, StaffAudienceProps, UntargetedStaffAudienceProps, newUntargetedStaffAudienceProps, newStaffAudienceProps } from '../../../../../models/FormProps';
import { isNotEmpty } from '../../../../../utils/equality';
import TargetedStaffImage from '../../../../../../../assets/images/targeted_untargeted_selector/targeted-staff.svg';
import UntargetedStaffImage from '../../../../../../../assets/images/targeted_untargeted_selector/untargeted-staff.svg';
import AudienceGuide from '../common/AudienceGuide';

interface Props {
  viewableAudience: StaffAudienceProps | UntargetedStaffAudienceProps;
  viewOnly: boolean;
  updateViewableAudienceCallback: (viewableAudience: StaffAudienceProps | UntargetedStaffAudienceProps) => void;
  formHasResponses: boolean;
  expectedAudience?: AudienceType;
}

export default function TargetedUntargetedStaffSelector(props: Props): React.ReactElement {
  const { viewableAudience, viewOnly, updateViewableAudienceCallback, formHasResponses, expectedAudience } = props;
  const isMobileOrTablet = useMediaQuery<Theme>(theme => theme.breakpoints.down('lg'));

  const isUnrestrictedAudience = !expectedAudience;

  return (
    <Stack spacing={0}>
      <AudienceGuide />
      <Stack direction={isMobileOrTablet ? 'column' : 'row'} justifyContent="center" alignItems="center" spacing={3} sx={{ mt: '32px' }}>
        {(isUnrestrictedAudience || expectedAudience === AudienceType.STAFF) && (
          <Button
            className={viewableAudience.type === AudienceType.STAFF
              ? 'audience-editor-button-selected' : 'audience-editor-button'}
            variant="outlined"
            onClick={() => selectTargetedAudienceCallback()}
            disabled={viewOnly}
          >
            <img alt="Specific staff only" src={TargetedStaffImage} className="audience-editor-button-image" />
          </Button>
        )}
        {(isUnrestrictedAudience || expectedAudience === AudienceType.UNTARGETED_STAFF) && (
          <Button
            className={viewableAudience.type === AudienceType.UNTARGETED_STAFF ? 'audience-editor-button-selected' : 'audience-editor-button'}
            variant="outlined"
            onClick={() => selectUntargetedAudienceCallback()}
            disabled={viewOnly}
          >
            <img alt="Any staff" src={UntargetedStaffImage} className="audience-editor-button-image" />
          </Button>
        )}
      </Stack>
    </Stack>
  );

  function selectTargetedAudienceCallback() {
    if (viewableAudience.type === AudienceType.UNTARGETED_STAFF) {
      if (formHasResponses && !confirm('This will restrict the form audience to selected staff. If you have already collected responses, make sure you select those staff in the next page to continue viewing their responses. Click to proceed.')) return;
      updateViewableAudienceCallback(newStaffAudienceProps());
    }
  }

  function selectUntargetedAudienceCallback() {
    if (viewableAudience.type === AudienceType.STAFF) {
      if (isNotEmpty(viewableAudience.entities) && !confirm('This will delete all currently selected groups and individuals. Click to proceed.')) return;
      updateViewableAudienceCallback(newUntargetedStaffAudienceProps());
    }
  }
}
